
import Vue from 'vue';
import helper from '../../../utils/helper';
import listCountry from '../../../utils/countryList';

import ArrowDown from '../../../Icons/ArrowDownLight.vue';
import EyeIcon from '../../../Icons/Eye.vue';
import EyeSlashIcon from '../../../Icons/EyeSlash.vue';

import Button from '../Button/Button.vue';
import EuInput from '../Input/Input.vue';
import FullPageModal from '../../Modal/FullPageModal.vue';
import EuDropdown from '../Dropdown/Dropdown.vue';
/**
<h5> For Input Phone Number; input must be in Object in this kind of format: </h5>
          { phoneCode: '+62',
            phoneNo: '34567',
            fullPhoneNo: '+6234567'}
**/
export default Vue.extend<any, any, any, any>({
  name: 'InputNumber',
  data() {
    return {
      focus: false,
      open: false,
      selectedItem: {},
      active: false,
      selectedCountry: 'Indonesia',
      countryCode: '+62',
      countryInitial: 'ID',
      list: listCountry,
      search: '',
      filterKey: '#',
      phoneNum: '',
      firstLoad: false,
      isSecurityActive: true
    };
  },
  components: {
    ArrowDown,
    Button,
    EuInput,
    FullPageModal,
    EuDropdown,
    EyeIcon,
    EyeSlashIcon
  },
  props: {
    /**
     * Value of input
     */
    value: {
      type: [String, Number, Object],
      default: '',
      required: true
    },
    /**
     * Set maximum length for input value (for all types)
     */
    maxLength: {
      type: Number,
      default: Number.POSITIVE_INFINITY
    },
    /**
     * Set minimum length for input value (for all types)
     */
    minLength: {
      type: Number,
      default: 0
    },
    /**
     * Set exact length for input value (for all types)
     */
    exactLength: {
      type: Number
    },
    /**
     * The ID, can be string or number
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set placeholder in the input
     */
    placeholder: {
      type: String,
      default: 'Placeholder here'
    },
    /**
     * Set input on error state
     */
    error: {
      type: Boolean,
      default: false
    },
    /**
     * Set input on success state
     */
    success: {
      type: Boolean,
      default: false
    },
    /**
     * Put label below the input
     */
    bottomLabel: {
      type: String,
      default: ''
    },
    /**
     * Change input formatter type (example: currency)
     */
    format: {
      type: String,
      default: ''
    },
    /**
     * Set the separator for currency (example: , or .)
     */
    separator: {
      type: String,
      default: ','
    },
    /**
     * To show the left label, set the label text
     */
    fieldLabel: {
      type: String,
      default: ''
    },
    /**
     * Set image on the left label
     */
    imageField: {
      type: String,
      default: ''
    },
    /**
     * To show arrow
     */
    selectionLabel: {
      type: Boolean,
      default: false
    },
    /**
     * Set arrow color
     */
    arrowColor: {
      type: String,
      default: '#f87300'
    },
    /**
     * To show the check function, use this to set the check label
     */
    checkLabel: {
      type: String,
      default: ''
    },
    /**
     * To make the check button disabled
     */
    disabledCheck: {
      type: Boolean,
      default: false
    },
    /**
     * To customize own section on left or right side inside input
     */
    customSection: {
      type: String,
      default: ''
    },
    /**
     * To apply dropdown selection on left side of input
     */
    selectionOptions: {
      type: Array
    },
    /**
     * Set button type (primary, secondary, default, destructive)
     */
    buttonType: {
      type: String,
      default: 'primary'
    },
    /**
     * Clickonly dropdown
     */
    clickonly: {
      type: Boolean,
      default: false
    },
    /**
     * Close label on tray (phone number input)
     */
    modalTitle: {
      type: String,
      default: 'Modal Title'
    },
    /**
     * Pass custom regex
     */
    customRegex: {
      type: String,
      default: ''
    },
    /**
     * Set InputAdvanced to required
     */
    required: {
      type: Boolean,
      default: false
    },
    /**
     * Make the input prevent to paste
     */
    pasteInput: {
      type: Boolean,
      default: true
    },
    /**
     * Set no border between label and input section
     */
    noBorder: {
      type: Boolean,
      default: false
    },
    /**
     * Set dropdown arrow icon
     */
    dropdownArrowIcon: {
      type: Object,
      default: () => ArrowDown
    },
    /**
     * Make the input text auto capitalize
     */
    capitalize: {
      type: Boolean,
      default: false
    },
    /**
     * Custom show password icon
     */
    showPasswordIcon: {
      type: [Object, Function],
      default: () => EyeIcon
    },
    /**
     * Custom hide password icon
     */
    hidePasswordIcon: {
      type: [Object, Function],
      default: () => EyeSlashIcon
    },
    /**
     * Custom password color fill
     */
    passwordIconFill: {
      type: String,
      default: '#8d8d8d'
    }
  },
  created() {
    this.firstLoad = true;
    if (this.selectionOptions) {
      this.fillSelectionField();
    }
    if (this.format === 'phonenumber') {
      this.fillPhoneNumber();
    }
    if (this.required) {
      let value = this.value;
      if (this.selectionOptions) value = this.value.value;
      this.handleInputState(value ? true : null);
    }
  },
  computed: {
    containerClasses() {
      return {
        focus: this.focus,
        error: this.error || this.isInvalidPhoneNumber,
        success: this.success,
        disabled: this.$attrs.disabled === true,
        nopadding: this.isRequiredLeftField || !!this.customSection,
        check: !!this.checkLabel || this.customSection === 'right',
        openborder: this.open,
        'no-border': this.noBorder,
        capitalize: this.capitalize,
        password: this.format === 'password'
      };
    },
    modifiedVal() {
      let val = '';
      let value = this.value;
      if (this.selectionOptions) {
        value = this.value.value;
      }
      if (this.format === 'phonenumber') {
        val = this.phoneNum;
      } else if (this.format === 'currency' && value) {
        const stringValue = String(value);
        val = this.currencyFormat(stringValue.replace(/[.,\s]/g, ''));
      } else {
        val = value;
      }
      return val;
    },
    modifiedType() {
      const type = this.$attrs.type ? this.$attrs.type : 'text';
      if (this.format === 'password' && this.isSecurityActive) {
        return 'password';
      }
      return type;
    },
    isInvalidPhoneNumber() {
      let isInvalid = false;
      if (this.format === 'phonenumber') {
        isInvalid =
          (this.required && !this.phoneNum) ||
          (!!this.phoneNum && !helper.isValidPhoneNumber(this.countryCode + this.phoneNum, this.countryInitial));
        this.handlChangeState(!isInvalid);
      }
      return isInvalid;
    },
    bottomLabelStyle() {
      return this.error ? `color: red` : this.success ? `color: #0ec376` : '';
    },
    isIntegerNumber() {
      return this.$attrs.type === 'number' || this.format === 'currency';
    },
    isRequiredLeftField() {
      return (
        !!this.fieldLabel ||
        !!this.imageField ||
        !!this.selectionOptions ||
        this.clickonly ||
        this.format === 'phonenumber'
      );
    },
    countries() {
      const filteredCountries = listCountry.filter(country => {
        const key = this.search.toLowerCase();
        const filterKey = this.filterKey.toLowerCase();
        const name = country.name.toLowerCase();
        if (filterKey !== '#') {
          return name[0] === filterKey && name.indexOf(key) >= 0;
        }
        return name.indexOf(key) >= 0;
      });
      return filteredCountries;
    },
    computedEyeIcon() {
      if (this.isSecurityActive) {
        return this.showPasswordIcon;
      }
      return this.hidePasswordIcon;
    }
  },
  methods: {
    fillSelectionField() {
      if (this.value.select) {
        const selectionFind = (this.selectionOptions as any[]).find(selection => selection.value === this.value.select);
        this.selectedItem = selectionFind;
      } else {
        this.selectedItem = this.selectionOptions[0];
      }
    },
    fillPhoneNumber() {
      if (this.value && this.value.phoneCode) {
        this.phoneNum = this.value.phoneNo;
        this.countryCode = this.value.phoneCode;
        const countryFind = (this.list as any[]).find(country => country.phoneCode === this.countryCode);
        this.countryInitial = countryFind.countryCode;
        this.selectedCountry = countryFind.name;
      }
    },
    flagCountry(country: String) {
      let countryName = country.replace(/ /g, '_');
      countryName = countryName.replace(/\./g, '');
      return countryName;
    },
    selectCountry(selectedCountry: any) {
      let valuePhone = {};
      const countryFind = (this.list as any[]).find(country => country.countryCode === selectedCountry.countryCode);
      this.countryInitial = countryFind.countryCode;
      this.countryCode = countryFind.phoneCode;
      this.selectedCountry = countryFind.name;
      this.active = false;
      let value = String(this.value.fullPhoneNo);
      valuePhone = {
        phoneCode: this.countryCode,
        phoneNo: this.value.phoneNo,
        fullPhoneNo: this.countryCode + value.replace(this.value.phoneCode, '')
      };
      /**
       * Input value
       * @event input
       * @type {function}
       */
      this.$emit('input', valuePhone);
      /**
       * Callback when user select the country
       * @event select-country-phone-modal
       * @type {function}
       */
      this.$emit('select-country-phone-modal', valuePhone);
    },
    currencyFormat(val: String) {
      const parts = val.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.separator);
      return parts.join(this.separator);
    },
    validationResult(valueData: String) {
      let validationState = true;
      if (this.required) {
        let value = valueData;
        if (this.selectionOptions) value = this.value.value;
        if (this.format === 'phonenumber') value = this.value.phoneNo;
        validationState = validationState && !!value && value.length > 0;
      }
      if (this.format === 'phonenumber') {
        validationState = !this.isInvalidPhoneNumber;
      }
      if (this.format === 'currency' || this.format === 'decimals') {
        valueData = valueData.replace(/[.,\s]/g, '');
      }
      if (this.minLength > 0) {
        validationState =
          (validationState && valueData.length >= this.minLength) || (valueData.length === 0 && !this.required);
      }
      if (this.exactLength) {
        validationState =
          (validationState && valueData.length === this.exactLength) || (valueData.length === 0 && !this.required);
      }
      return validationState;
    },
    handleFocus(e: Event) {
      this.focus = true;
      /**
       * When on focus
       * @event focus
       * @type {function}
       */
      this.$emit('focus', e);
    },
    handleBlur(e: Event) {
      this.focus = false;
      const valueData = (e.target as HTMLInputElement).value;
      const validationState = this.validationResult(valueData);
      this.handleInputState(validationState);
      /**
       * On blur
       * @event blur
       * @type {function}
       */
      this.$emit('blur', e);
    },
    handleInput(e: Event) {
      let valueData = (e.target as HTMLInputElement).value;
      let valueObject = {};
      let valuePhone = {};
      if (this.format === 'currency') {
        const stringValue = String(valueData);
        valueData = this.currencyFormat(stringValue.replace(/[.,\s]/g, ''));
      }
      if (this.capitalize) {
        valueData = valueData.toUpperCase();
      }
      if (this.selectionOptions) {
        valueObject = {
          select: this.selectedItem.value,
          value: valueData
        };
        this.$emit('input', valueObject);
      } else if (this.format === 'phonenumber') {
        let phone = this.countryCode + valueData;
        valuePhone = {
          phoneCode: this.countryCode,
          phoneNo: valueData,
          fullPhoneNo: phone
        };
        this.phoneNum = valueData;
        /**
         * Input value
         * @event input
         * @type {function}
         */
        this.$emit('input', valuePhone);
      } else {
        /**
         * Input value
         * @event input
         * @type {function}
         */
        this.$emit('input', valueData);
      }
    },
    handleChange(e: Event) {
      let valueData = (e.target as HTMLInputElement).value;
      let valuePhone = {};
      if (this.format === 'currency' || this.format === 'decimals') {
        valueData = valueData.replace(/[.,\s]/g, '');
      }
      if (valueData.length > this.maxLength || (this.format === 'currency' && !helper.isNumeric(valueData))) {
        this.$emit('input', '');
      }
      if (this.format === 'phonenumber') {
        const stringPhone = String(this.phoneNum);
        let phoneNumber = stringPhone.replace(/\D/g, '');
        if (phoneNumber.charAt(0) === '0') phoneNumber = phoneNumber.substr(1);
        let phone = this.countryCode + phoneNumber;
        valuePhone = {
          phoneCode: this.countryCode,
          phoneNo: phoneNumber,
          fullPhoneNo: phone
        };
        /**
         * Input value
         * @event input
         * @type {function}
         */
        this.$emit('input', valuePhone);
      }
      /**
       * On change
       * @event change
       * @type {function}
       */
      this.$emit('change', e);
    },
    handleKeyPress(e: any) {
      const regex = RegExp(this.customRegex);
      let valueData = (e.target as HTMLInputElement).value;
      if (this.format === 'currency' || this.format === 'decimals') {
        valueData = valueData.replace(/[.,\s]/g, '');
      }
      // @ts-ignore
      if (
        (!!this.customRegex && !regex.test(e.key)) ||
        valueData.length >= this.maxLength ||
        (valueData.length >= this.exactLength && this.exactLength) ||
        (/[^0-9]/g.test(e.key) && this.isIntegerNumber) ||
        (!helper.isAlphabetic(e.key) && this.format === 'text') ||
        (!helper.isDecimal(e.key) && this.format === 'decimals') ||
        (this.format === 'currency' && valueData == '0' && e.key == '0')
      ) {
        e.preventDefault();
      }
      const completedValue = String(valueData + e.key);
      const validationState = this.validationResult(completedValue);
      if (this.format !== 'phonenumber') {
        this.handlChangeState(validationState);
      }
      /**
       * On keypress
       * @event keypress
       * @type {function}
       */
      this.$emit('keypress');
    },
    handleInputState(state: Boolean) {
      /**
       * Validation state returns when on blur. This method works in these conditions:
       * 1. if props required is given. Meaning if the value is null, inputState = false.
       * 2. the input length doesn't fit minLength/exactLength props given. Example, if minLength is 5 and value length is 3; inputState = false
       * 3. Phonenumber format.
       * @event inputState
       * @type {function}
       */
      this.$emit('inputState', state);
    },
    handlChangeState(state: Boolean) {
      /**
       * Validation state returns when on keypress. This method works in these conditions:
       * 1. if props required is given. Meaning if the value is null, changeState = false.
       * 2. The input length doesn't fit minLength/exactLength props given. Example, if minLength is 5 and value length is 3; changeState = false
       * 3. Phonenumber format.
       * @event changeState
       * @type {function}
       */
      this.$emit('changeState', state);
    },
    handlePaste(e: Event) {
      if (!this.pasteInput) {
        e.preventDefault();
        return;
      }
    },
    activate() {
      this.open = true;
      (this.$el as HTMLElement).focus();
    },
    deactivate() {
      this.open = false;
      (this.$el as HTMLElement).blur();
    },
    handleClick(e: Event) {
      /**
       * Click left field
       * @event click
       * @type {function}
       */
      this.$emit('click', e);
    },
    handleSelect(val: any) {
      this.selectedItem = val;
      let valueObject = {
        select: val.value,
        value: ''
      };
      if (this.firstLoad && this.value.value) {
        valueObject.value = this.value.value;
        this.firstLoad = false;
      }
      /**
       * Input value
       * @event input
       * @type {function}
       */
      this.$emit('input', valueObject);
    },
    handleSecurityMaskClick() {
      this.isSecurityActive = !this.isSecurityActive;
    },
    handleOpenPhoneModal() {
      this.active = true;
      /**
       * Callback when open the select country phone number.
       * @event open-phone-modal
       * @type {function}
       */
      this.$emit('open-phone-modal');
    }
  }
});
